import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { evaluate, exportData } from "./vvinaleService";

const exportErrorMessage = async (error) => {
    const responseData = error?.response?.data;
    if (responseData instanceof Blob) {
        try {
            const body = JSON.parse(await responseData.text());
            return body?.message || "Impossible de générer le rapport PDF.";
        } catch (parseError) {
            return "Impossible de générer le rapport PDF.";
        }
    }
    return responseData?.message || "Impossible de générer le rapport PDF.";
};

const vvinaleSlice = createModule({
    name: "vvinale",
    initialState: {
        vvinales: [],
        isFetchingV: false,
        error: null
    },
    reducers: {
        evaluate: (state) => {
            state.isFetchingV = true;
        },
        save: (state) => {
            state.isFetchingV = true;
        },
        exportData: (state) => {
            state.isFetchingV = true;
        },
        list: (state) => {
            state.isFetchingV = true;
        },
        find: (state) => {
            state.isFetchingV = true;
        },

        fetchedData: (state, payload) => {
            state.vvinales = payload.body;
        },
        finishFetching: (state) => {
            state.isFetchingV = false;
        },
        fetchError: (state) => {
            state.isFetchingV = false;
            state.error = "An error occurred";
        },
    },
    sagas: (A) => ({

        *[A.evaluate]({ payload }) {
            try {
                const { data } = yield evaluate(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                const message = e?.response?.data?.message || "Impossible d'évaluer ce véhicule.";
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) yield call(payload.onError, message);
            }
        },
        *[A.exportData]({ payload }) {
            try {
                const { data } = yield call(exportData, payload.data);

                const fileBlob = data instanceof Blob
                    ? data
                    : new Blob([data], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(fileBlob);

                const link = document.createElement("a");
                link.href = fileURL;
                link.download = "evaluation-valeur-venale.pdf";
                document.body.appendChild(link);
                link.click();
                link.remove();
                setTimeout(() => URL.revokeObjectURL(fileURL), 1000);

                yield put(A.finishFetching());
                if (payload?.onSuccess) yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                const message = yield call(exportErrorMessage, e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) yield call(payload.onError, message);
            }
        }
        // *[A.createVvinale]({payload}) {
        //     try {
        //         console.log(payload.data);
        //         yield createVvinale(payload.data);
        //         yield put(A.finishFetching());
        //         yield call(payload.onSuccess);
        //     } catch (e) {
        //         console.log(e);
        //         yield put(A.finishFetching());
        //         yield put(A.fetchError());
        //     }
        // },
        // *[A.listVvinale]() {
        //     try {
        //         const { data } = yield listVvinale();
        //         yield put(A.finishFetching());
        //         yield put(A.fetchedData(data));
        //     } catch (e) {
        //         console.log(e);
        //         yield put(A.finishFetching());
        //         yield put(A.fetchError());
        //     }
        // },
        // *[A.updateVvinale]({payload}) {
        //     try {
        //         yield updateVvinale(payload.data);
        //         yield put(A.finishFetching());
        //         yield call(payload.onSuccess);
        //     } catch (e) {
        //         console.log(e);
        //         yield put(A.finishFetching());
        //         yield put(A.fetchError());
        //     }
        // }

    })
})

export default vvinaleSlice;
export const vvinaleActions = vvinaleSlice.actions;
